import React from 'react'
import { useTranslate } from '../TranslationText'
import NewActionButton from '../ActionButtons/NewActionButton';
import { eformFormButton } from '../../common/cssclasses';
import { isAssistant } from '../../helper/IsAssistant';

export default function SubmitAndPay({ selectedAccountId , ...props  }) {
    const { translate } = useTranslate();
    // {translate("web.submit", "Submit")}

    const isNoPay = isAssistant(selectedAccountId);

    return (
        <div className={eformFormButton}>
            <NewActionButton
                classNames={"btn-danger"}
                text={
                    <>
                        <i className="fa-solid fa-circle-check"></i>
                        {isNoPay ? translate("web.submit", "Submit") : translate("web.submitPay", "Submit And Pay")}
                    </>
                }
                {...props}
            />
        </div>
    )
}
